<div class="container-fluid" [wl-busy-overlay]="loadingEventItem">
  <div class="mct-flex mct-row mb-3">
    <h3>
      {{ 'events.settings.items.title' | translate | titlecase }}
      <a
        href="https://support.weblinkinternational.com/hc/en-us/articles/235709787-Event-Settings-Event-Items"
        target="_blank"
        class="ml-2"
      >
        <i class="pi pi-question-circle wc-help-icon" [title]="'events.settings.items.items-title-help' | translate"></i>
      </a>
    </h3>
  </div>

  <div class="mct-flex mct-row mb-16">
    <button
      app-add-button
      dataCy="btnEventSettingsNewEventItem"
      [disabled]="userAccessLevel < 2"
      [label]="'events.settings.items.add-event-item-label' | translate | titlecase"
      (click)="newEventItem()"
    ></button>
  </div>
  <div class="mct-flex mct-row mct-justify-between mct-items-center mb-12">
    <p>
      {{ 'events.settings.items.drag-drop-instructions' | translate }}
    </p>
    <a (click)="openEventDetailsModal()">
      {{ 'events.settings.items.event-item-details.view-event-item-details' | translate | titlecase }}
    </a>
  </div>

  <div [hidden]="!loadingList.busy" class="my-3 mct-flex mct-row mct-gap-10">
    <wl-busy [show]="loadingList.busy"></wl-busy>
    <span>{{ 'common.loading' | translate | titlecase }}...</span>
  </div>

  <div class="alert alert-danger" [hidden]="loadingList.busy || loadingList.success || !loadingList.message">
    {{ loadingList.message }}
  </div>

  <div cdkDropList (cdkDropListDropped)="handleEventItemDrop($event)" class="list-group shadow-sm" [hidden]="!eventItems?.length">
    <div cdkDrag cdkDragHandle class="list-group-item mct-flex mct-row mct-justify-between mct-items-center" *ngFor="let eventItem of eventItems">
      <div class="mct-flex mct-row mct-justify-center mct-items-center mct-gap-3">
        <i class="pi pi-bars mr-3 text-muted" style="cursor: move"></i>
        <div class="mct-flex mct-col">
          <span class="font-weight-bold">{{ eventItem.Descr }}</span>

          <div class="small text-muted mt-1">
            <div>
              <i class="pi pi-tag mr-1" style="font-size: 0.8rem"></i>
              <span *ngIf="!eventItem.HasMemberPricing">
                {{ eventItem.NonMemberPrice | currency }}
              </span>
              <span *ngIf="eventItem.HasMemberPricing">
                {{ eventItem.NonMemberPrice | currency }} / {{ eventItem.MemberPrice | currency }} (Member)
              </span>
            </div>
            <div>
              <span *ngIf="eventItem.IsPublic" class="ml-2 badge badge-success"> <i class="pi pi-globe mr-1"></i> Public </span>
            </div>
          </div>
        </div>
      </div>

      <div class="mct-flex mct-row mct-gap-3">
        <button
          pButton
          type="button"
          class="atlas-btn atlas-btn-primary p-button-text p-button-md"
          (click)="editEventItem(eventItem.EventItemId)"
          [disabled]="loadingList.busy || userAccessLevel < 2"
          icon="pi pi-pencil"
        ></button>
        <button
          pButton
          type="button"
          class="p-button-text atlas-btn atlas-btn-secondary p-button-md"
          (click)="copyEventItem(eventItem)"
          [title]="'events.settings.items.copy-item' | translate | titlecase"
          icon="pi pi-copy"
        ></button>
        <button
          pButton
          type="button"
          class="p-button-text atlas-btn atlas-btn-danger p-button-md"
          (click)="confirmDeleteEventItem(eventItem)"
          [disabled]="loadingList.busy || userAccessLevel < 2"
          icon="pi pi-trash"
        ></button>
      </div>
    </div>
  </div>

  <app-back-to-top></app-back-to-top>
</div>

<wl-event-v4-item-details-modal> </wl-event-v4-item-details-modal>

<p-dialog
  #eventItemEditModal
  [modal]="true"
  [(visible)]="showEditModal"
  [closable]="true"
  styleClass="atlas-dialog-l"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
  baseZIndex="3"
>
  <ng-template #header>
    <h4 class="modal-title">
      {{ 'events.settings.items.title-singular' | translate | titlecase }}
      <small class="text-muted ml-2" *ngIf="selectedEventItem.EventItemId > 0"> #{{ selectedEventItem.EventItemId }} </small>
    </h4>
  </ng-template>

  <p [hidden]="!loadingEventItem"><wl-busy [show]="loadingEventItem"></wl-busy> {{ 'common.loading' | translate | titlecase }}...</p>
  <div class="container-fluid" [hidden]="loadingEventItem">
    <form id="eventItemForm" #eventItemForm="ngForm" novalidate (ngSubmit)="saveEventItem(eventItemForm)" class="form-horizontal">
      <div class="form-group" [ngClass]="{ 'has-error': !selectedEventItem?.Descr || selectedEventItem?.Descr?.length > 250 }">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.descr-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <input
            class="form-control"
            name="Descr"
            type="text"
            data-cy="inputEventSettingsItemName"
            [(ngModel)]="selectedEventItem.Descr"
            required
          />
          <div class="help-block" *ngIf="selectedEventItem?.Descr?.length > 250">
            {{
              'common.maxlength-exceeded' | translate: { field: ('events.settings.items.descr-label' | translate | titlecase), max: 250 }
            }}
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.long-description-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <textarea
            [(ngModel)]="selectedEventItem.LongDescription"
            name="LongDescription"
            pInputTextarea
            [autoResize]="true"
            class="w-100"
            maxlength="200"
          ></textarea>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.attendees-for-item-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <input
            class="form-control"
            type="text"
            data-cy="inputEventSettingsItemAttendeeNumber"
            name="AttendeesForItem"
            [(ngModel)]="selectedEventItem.AttendeesForItem"
          />
        </div>
      </div>
      <div class="form-group" [ngClass]="{ 'has-error': revenueItemRequired && !selectedEventItem?.ItemNum }">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.revenue-item-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <wl-revenue-item-selector
            [(ngModel)]="selectedEventItem.ItemNum"
            [ngModelOptions]="{ standalone: true }"
            (onRevenueItemChanged)="revenueItemChanged($event)"
            data-cy="inputEventSettingsRevenueItemNum"
          ></wl-revenue-item-selector>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.payment-types-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <p-select
            appendTo="body"
            name="PaymentTypeId"
            [(ngModel)]="selectedEventItem.PaymentTypeId"
            [style]="{ width: '100%' }"
            [options]="paymentTypeItems"
            [placeholder]="'common.none' | translate | titlecase"
            [showClear]="true"
          ></p-select>
        </div>
      </div>
      <div [hidden]="true" class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.default-adjustment-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <p-select
            appendTo="body"
            name="DefaultAdjustmentTypeId"
            [(ngModel)]="selectedEventItem.DefaultAdjustmentTypeId"
            [style]="{ width: '100%' }"
            [options]="adjustmentTypeItems"
            [placeholder]="'common.none' | translate | titlecase"
            [showClear]="true"
          ></p-select>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-offset-3 col-sm-9">
          <label>
            <input type="checkbox" name="IsSponsorShip" [(ngModel)]="selectedEventItem.IsSponsorShip" />
            {{ 'events.settings.items.is-a-sponsorship-label' | translate | titlecase }}
          </label>
          <div>
            <label>
              <input type="checkbox" name="IsPublic" [(ngModel)]="selectedEventItem.IsPublic" />
              {{ 'events.settings.items.is-public-label' | translate | titlecase }}
              <img
                class="wc-inline-icon"
                src="/assets/img/public-registration.png"
                [title]="'events.settings.items.public-registration-available' | translate"
                [alt]="'events.settings.items.public-registration-available' | translate"
              />
            </label>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.inoive-due-date-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <span class="mr-10">
            <wl-date-selector
              name="eventItemInvoicDateDue"
              [(ngModel)]="selectedEventItem.InvoiceDateDue"
              [disabled]="selectedEventItem.UseRegistrationDateForInvoiceDueDate"
            ></wl-date-selector>
          </span>
          <label>
            <input
              type="checkbox"
              name="UseRegistrationDateForInvoiceDueDate"
              [(ngModel)]="selectedEventItem.UseRegistrationDateForInvoiceDueDate"
            />
            {{ 'events.settings.items.use-registration-date-label' | translate | titlecase }}
          </label>
          <input
            pInputText
            name="DaysAfterRegistrationDateForInvoiceDueDate"
            [(ngModel)]="selectedEventItem.DaysAfterRegistrationDateForInvoiceDueDate"
            type="number"
            class="width-10pct"
          />
          {{ 'events.settings.items.use-registration-date-plus-days-label' | translate | titlecase }}
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.sales-dates-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <span class="wl-give-calendar-right-padding">
            <wl-date-selector name="startDate" [(ngModel)]="selectedEventItem.StartDate"></wl-date-selector>
          </span>
          {{ 'events.settings.items.to-label' | translate | titlecase }}
          <wl-date-selector name="endDate" [(ngModel)]="selectedEventItem.EndDate"></wl-date-selector>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.max-items-avail-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <input class="form-control" type="text" name="MaxItemsAvail" [(ngModel)]="selectedEventItem.MaxItemsAvail" />
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.max-quantity-per-registration-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <input class="form-control" type="text" name="LimitPerRegistration" [(ngModel)]="selectedEventItem.LimitPerRegistration" />
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.pricing-and-restrictions-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <div class="form-control-static">
            <label
              ><input
                type="checkbox"
                name="HasMemberPricing"
                [(ngModel)]="selectedEventItem.HasMemberPricing"
                (ngModelChange)="handleEventItemEditHasMemberPricingChecked()"
              />
              {{ 'events.settings.items.member-nonmember-pricing-label' | translate | titlecase }}</label
            >
          </div>
        </div>
      </div>
      <div class="form-group" [hidden]="selectedEventItem.HasMemberPricing">
        <label class="col-sm-3 control-label" *ngIf="!selectedEventItem.MembersOnly">
          {{ 'events.settings.items.unit-price-label' | translate | titlecase }}
        </label>
        <label class="col-sm-3 control-label" *ngIf="selectedEventItem.MembersOnly">
          {{ 'events.settings.items.member-price-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <input
            class="form-control"
            type="text"
            data-cy="inputEventSettingsItemPrice"
            *ngIf="!selectedEventItem.MembersOnly"
            name="NonMemberPrice"
            [(ngModel)]="selectedEventItem.NonMemberPrice"
          />
          <input
            class="form-control"
            type="text"
            *ngIf="selectedEventItem.MembersOnly"
            name="MemberPrice"
            [(ngModel)]="selectedEventItem.MemberPrice"
          />
        </div>
      </div>
      <div class="form-group" [hidden]="!selectedEventItem.HasMemberPricing">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.nonmember-price-label' | translate | titlecase }}
        </label>
        <div class="col-sm-3">
          <input class="form-control" type="text" name="NonMemberPrice" [(ngModel)]="selectedEventItem.NonMemberPrice" />
        </div>
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.member-price-label' | translate | titlecase }}
        </label>
        <div class="col-sm-3">
          <input class="form-control" type="text" name="MemberPrice" [(ngModel)]="selectedEventItem.MemberPrice" />
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-offset-3 col-sm-9">
          <label>
            <input type="checkbox" name="Taxable" [(ngModel)]="selectedEventItem.Taxable" />
            {{ 'events.settings.items.is-taxable-label' | translate | titlecase }}
          </label>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-offset-3 col-sm-9">
          <div>
            <label [ngClass]="{ disabled: selectedEventItem.HasMemberPricing }">
              <input
                type="checkbox"
                name="MembersOnly"
                [(ngModel)]="selectedEventItem.MembersOnly"
                [disabled]="selectedEventItem.HasMemberPricing"
                [hidden]="selectedEventItem.HasMemberPricing"
                (ngModelChange)="handleMembersOnlyChanged()"
              />
              <input type="checkbox" [hidden]="!selectedEventItem.HasMemberPricing" disabled />
              {{ 'events.settings.items.members-only-label' | translate | titlecase }}
            </label>
          </div>
          <div>
            <label>
              <input
                type="checkbox"
                name="AllowRelateProfileMemberPrice"
                [(ngModel)]="selectedEventItem.AllowRelateProfileMemberPrice"
                [disabled]="!selectedEventItem.MembersOnly && !selectedEventItem.HasMemberPricing"
                [hidden]="!selectedEventItem.MembersOnly && !selectedEventItem.HasMemberPricing"
              />
              <input type="checkbox" disabled [hidden]="selectedEventItem.MembersOnly || selectedEventItem.HasMemberPricing" />
              {{ 'events.settings.items.allow-related-profile-member-price-label' | translate | titlecase }}
            </label>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-offset-3 col-sm-9">
          <label>
            <input type="checkbox" name="RestrictForAffiliations" [(ngModel)]="selectedEventItem.RestrictForAffiliations" />
            {{ 'events.settings.items.restrict-for-affiliations-label' | translate | titlecase }}
          </label>
        </div>
      </div>
      <div class="form-group" [hidden]="!selectedEventItem.RestrictForAffiliations">
        <div class="col-sm-offset-3 col-sm-9">
          <wl-affcode-selector #affCodeSelectorComponent name="AffCodes" [(ngModel)]="selectedEventItem.AffCodes"></wl-affcode-selector>
        </div>
      </div>
      <div [hidden]="!selectedEventItem.MembersOnly && !selectedEventItem.RestrictForAffiliations">
        <div class="form-group">
          <label class="col-sm-3 control-label">
            {{ 'events.settings.items.teaser-message-label' | translate | titlecase }}
          </label>
          <div class="col-sm-9">
            <input class="form-control" type="text" name="TeaserMessage" [(ngModel)]="selectedEventItem.TeaserMessage" />
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 control-label">
            {{ 'events.settings.items.restricted-message-label' | translate | titlecase }}
          </label>
          <div class="col-sm-9">
            <input class="form-control" type="text" name="RestrictedMessage" [(ngModel)]="selectedEventItem.RestrictedMessage" />
          </div>
        </div>
      </div>
      <div class="form-group" [hidden]="!selectedEventItem.MembersOnly && !selectedEventItem.RestrictForAffiliations">
        <div class="col-sm-offset-3 col-sm-9">
          <label>
            <input type="checkbox" name="ShowForEligibleUsersOnly" [(ngModel)]="selectedEventItem.ShowForEligibleUsersOnly" />
            {{ 'events.settings.items.show-for-eligible-users-only-label' | translate | titlecase }}
          </label>
          <img
            src="/assets/img/help.png"
            title="{{ 'events.settings.items.show-for-eligible-users-only-tooltip-label' | translate }}"
            class="wc-help-icon"
          />
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.ceus-label' | translate }}
        </label>
        <div class="col-sm-9">
          <div class="form-control-static">
            <wl-event-v4-item-credit-type-list [eventItemCreditTypes]="selectedEventItem.CreditTypes"></wl-event-v4-item-credit-type-list>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label"> </label>
        <div class="col-sm-9">
          <div class="form-control-static">
            <input type="checkbox" name="CreateSeparateAttendee" [(ngModel)]="selectedEventItem.CreateSeparateAttendee" />
            {{ 'events.settings.items.separate-attendee' | translate | titlecase }}
          </div>
        </div>
      </div>
    </form>
  </div>

  <ng-template #footer>
    <div [hidden]="loadingEventItem">
      <div class="alert alert-danger text-left" *ngIf="editError">
        {{ editError }}
      </div>
      <div class="alert alert-warning text-left small" *ngIf="showEventItemPriceChangeWarning && !saving">
        <i class="pi pi-exclamation-triangle mr-1"></i> {{ 'events.settings.items.price-change-warning' | translate }}
      </div>

      <div class="mct-flex mct-row mct-justify-end mct-items-center mct-gap-10">
        <wl-busy [show]="saving"></wl-busy>
        <button
          pButton
          type="button"
          class="atlas-btn atlas-btn-primary"
          (click)="saveEventItem(eventItemForm)"
          [disabled]="saving || isFormInvalid(eventItemForm)"
          icon="pi pi-save"
          [label]="(saving ? 'common.saving' : 'common.save') | translate | titlecase"
        ></button>
        <button
          pButton
          type="button"
          class="atlas-btn atlas-btn-secondary"
          (click)="showEditModal = false"
          [disabled]="saving"
          icon="pi pi-ban"
          [label]="'common.cancel' | translate | titlecase"
        ></button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  #eventItemDeleteConfirmationModal
  modal="true"
  [(visible)]="showDeleteModal"
  [closable]="false"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
  baseZIndex="3"
>
  <div class="text-center p-3">
    <i class="pi pi-exclamation-triangle text-danger" style="font-size: 3rem"></i>

    <div class="mt-3" *ngIf="!eventItemHasRegistrations && checkingDelete.success">
      <h5>{{ 'events.settings.items.delete-prompt' | translate }}</h5>
    </div>

    <div class="alert alert-warning mt-3" *ngIf="eventItemHasRegistrations">
      {{ 'events.settings.items.delete-event-item-has-registrations-message' | translate }}
    </div>
  </div>

  <ng-template #footer>
    <div class="mct-flex mct-row mct-gap-10">
      <wl-busy [show]="deleting"></wl-busy>
      <button
        pButton
        type="button"
        class="atlas-btn btn-danger"
        (click)="deleteEventItemConfirmed()"
        [disabled]="deleting || eventItemHasRegistrations || !checkingDelete.success"
        icon="pi pi-trash"
        [label]="(deleting ? 'common.deleting' : 'common.delete') | translate | titlecase"
      ></button>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-secondary"
        (click)="showDeleteModal = false"
        [disabled]="deleting"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | titlecase"
      ></button>
    </div>
  </ng-template>
</p-dialog>
